import { useRef, useState } from 'react';
export function useMethodsExtensionNative(reducers, setState) {
    const methodsRef = useRef(undefined);
    if (!methodsRef.current) {
        methodsRef.current = Object.keys(reducers).reduce((methods, key) => {
            const fn = reducers[key];
            const bound = (...args) => setState(s => fn(s, ...args));
            Object.assign(methods, { [key]: bound });
            return methods;
        }, {});
    }
    return methodsRef.current;
}
export function useMethodsNative(reducers, initialState) {
    const [state, setState] = useState(initialState);
    const boundMethods = useMethodsExtensionNative(reducers, setState);
    return [state, boundMethods, setState];
}
//# sourceMappingURL=native.js.map